// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snAZgbReK3VCXF {
  margin-top: 16px;
  padding-left: 32px;
  font-size: 12px;
}
.snAZgbReK3VCXF a {
  margin-left: 4px;
  color: var(--ds-background-accent-blue-bolder, #0c66e4);
}
.snAZgbReK3VCXF a:hover {
  color: var(--ds-background-accent-blue-bolder, #0c66e4);
}
@media only screen and (max-width: 600px) {
  .snAZgbReK3VCXF {
    padding-right: 32px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"integrationsSection": `snAZgbReK3VCXF`
};
export default ___CSS_LOADER_EXPORT___;
